import React, { useState, useRef, useEffect } from 'react';
import { Animated, FlatList, Button } from 'react-native';
import firebase from '../firebase/Config';
import { getAuth, signOut } from "firebase/auth";
import '../public/app.module.css'

var ARTISTS = [];

function getName(name) {
  if (name == "") {
    return "Unnamed Artist"
  } else {
    return name;
  }
}

function getInitials(name) {
  var names = name.split(' '),
    initials = names[0].substring(0, 1).toUpperCase();

  if (names.length > 1) {
    initials += names[names.length - 1].substring(0, 1).toUpperCase();
  }

  return initials;
}

const Item = ({ name, onPress }) => (
  <div onClick={onPress} className="artistCell">
    <div className="initialsView">
      <span className="initialsText">{getInitials(name)}</span>
    </div>
    <span className="nameText">{name}</span>
  </div>
);

const ChooseArtistScreen = props => {

  const [refreshData, setRefreshData] = useState(false);

  const uId = firebase.auth().currentUser.uid;

  firebase.database().ref("users").child(uId).child("artists").once("value").then(snapshot => {
    ARTISTS = [];
    const artists = snapshot.val();
    return artists;
  }).then((artists) => {
    return Promise.all(Object.keys(artists).map((artistId) => {
      const artistRef = "/artists/" + artistId;
      return firebase.database().ref(artistRef).once("value").then(snapshot => {
        const artist = snapshot.val();
        ARTISTS.push({
          id: snapshot.key,
          name: getName(artist.metadata.name)
        });
      });
    }))
  }).then(() => {
    ARTISTS.sort((a, b) => (a.name > b.name) ? 1 : -1); // Sort alphabetically
    setRefreshData(true);
  }).catch((err) => {
    console.error(err);
  });

  const renderItem = ({ item }) => (
    <Item name={item.name} id={item.id} onPress={() => props.navigation.navigate('ChooseProjectScreen', { item })} />
  );

  const fadeAnim = useRef(new Animated.Value(0)).current  // Initial value for opacity: 0

  useEffect(() => {
      Animated.timing(
          fadeAnim,
          {
              toValue: 1,
              duration: 500,
          }
      ).start();
  }, [fadeAnim])


  function handleLogOutButtonClick() {
    const auth = getAuth();
    signOut(auth).then(() => {
      props.navigation.navigate('LoginScreen');
    }).catch((error) => {
      console.error(error);
    });
  }

  return (
    <div className="main">
      <div className="header">
          <div className="row">
              <div className="buttonView">
                  <Button
                      onPress={handleLogOutButtonClick}
                      title="Log Out"
                  />
              </div>
              <span className="headerText">Select an Artist</span>
          </div>
      </div>
      <div className="container">
        <Animated.View style={{ opacity: fadeAnim }}>
          <FlatList
            style={{flexGrow: 0}}
            extraData={refreshData}
            data={ARTISTS}
            renderItem={renderItem}
            keyExtractor={item => item.id}
            horizontal={true}
          />
         </Animated.View>
      </div>
    </div>
  );
}

export default ChooseArtistScreen;
